import { useEffect, useState } from 'react';
import { breakpointMedium, breakpointSmall } from '@/constants/breakpoints';

export const breakpointMdSmall = '768px';
const breakpointLg = `${parseInt(breakpointMedium) + 1}px` as const;

const breakpointsMap = {
  sm: `(max-width: ${breakpointSmall})`,
  mdSmall: `(max-width: ${breakpointMdSmall})`,
  md: `(max-width: ${breakpointMedium})`,
  lg: `(min-width: ${breakpointLg})`,
} as const;

type Breakpoint = keyof typeof breakpointsMap;

const breakpoints: Breakpoint[] = Object.keys(breakpointsMap) as Breakpoint[];

const useCustomBreakpoint = (): Breakpoint => {
  const [currentBreakpoint, setCurrentBreakpoint] =
    useState<Breakpoint>('lg');

  useEffect(() => {
    const evaluateBreakpoint = throttle(() => {
      for (const breakpoint of breakpoints) {
        if (window.matchMedia(breakpointsMap[breakpoint]).matches) {
          setCurrentBreakpoint(breakpoint);
          break;
        }
      }
    }, 100);

    evaluateBreakpoint();
    window.addEventListener('resize', evaluateBreakpoint);

    return () => window.removeEventListener('resize', evaluateBreakpoint);
  }, []);

  return currentBreakpoint;
};

export default useCustomBreakpoint;

type AnyFunc = (...args: any[]) => any;

export function throttle<T extends AnyFunc>(callback: T, delay = 0) {
  let timer: ReturnType<typeof setTimeout> | null = null;

  return () => {
    if (!timer) {
      timer = setTimeout(() => {
        callback();
        timer = null;
      }, delay);
    }
  };
}
